import { MoreHoriz } from "@mui/icons-material";
import { SlOptionsVertical } from "react-icons/sl";
import { GrUpdate } from "react-icons/gr";
import { useNavigate, useParams } from "react-router-dom";

import toIDR from "../../../hooks/toIDR";
import { IGNORE_TYPE, INVENTORY_STATUS } from "../../../constants/constant";

const ProductCard = ({
  item,
  productId,
  setProductId,
  setAnchorElProduct,
  handleSelectList,
  inventoryStatus,
  isWarehouse,
}) => {
  const { status } = useParams();
  const navigate = useNavigate();
  return (
    <div
      className="mt-3 flex items-center shadow-md !rounded-lg p-3 border-2 border-gray-300 justify-between"
      key={item.product_id}
    >
      <div className="flex items-center">
        <input
          id={item.product_id}
          type="checkbox"
          name={item.product_name}
          className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 focus:ring-2 "
          checked={productId.includes(item.product_id)}
          onChange={() => handleSelectList(item.product_id)}
        />
        <img
          src={item.media[0]}
          alt="foto_product"
          className="w-20 border rounded-lg mx-2"
        />
        <div className="flex flex-col gap-1 text-clip overflow-hidden">
          <a
            href={`${isWarehouse ? "/central-warehouse" : ""}/inventory/${
              INVENTORY_STATUS.find((item) => item.status === Number(status))
                .oldNav
            }/detail-product/${item.product_id}`}
            className="hover:none cursor-pointer"
          >
            {item.product_name}
          </a>
          <p className="font-bold">
            {toIDR(isWarehouse ? item.pharmacy_net_price : item.sell_price)} /{" "}
            {item.packing !== null && item.packing !== undefined
              ? item.packing.type_box
              : null}
          </p>
          <p>{item.distributor_name}</p>
          <p>Jumlah: {item.packaging_detail}</p>
          {isWarehouse ? null : (
            <div>
              Total stok warehouse: {item.stock_warehouse}{" "}
              {IGNORE_TYPE.includes(item.packing?.type_unit)
                ? item.packing?.type_strip
                : item.packing?.type_unit}
            </div>
          )}
        </div>
      </div>

      {inventoryStatus === 4 ? (
        <>
          <div className="shadow-md !rounded-lg">
            <button
              className="bg-green-400 px-3 !rounded-lg hidden lg:block font-medium py-1 hover:bg-green-600 hover:text-white"
              onClick={() =>
                navigate(
                  `${
                    isWarehouse ? "/central-warehouse" : ""
                  }/inventory/produk-hold/edit-product-details/${
                    item.product_id
                  }`
                )
              }
            >
              Update Information
            </button>
            <button
              className="bg-green-400 px-3 !rounded-lg block lg:hidden font-medium text-sm py-1 hover:bg-green-600 hover:text-white"
              onClick={() =>
                navigate(
                  `${
                    isWarehouse ? "/central-warehouse" : ""
                  }/inventory/produk-hold/edit-product-details/${
                    item.product_id
                  }`
                )
              }
            >
              <GrUpdate />
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="hidden md:block">
            <div
              className="hover:text-gray-300 cursor-pointer"
              onClick={(e) => {
                setAnchorElProduct(e.currentTarget);
                setProductId([item.product_id]);
              }}
            >
              <MoreHoriz />
            </div>
          </div>
          <div className="block md:hidden">
            <SlOptionsVertical
              className="hover:cursor-pointer hover:text-gray-300"
              onClick={(e) => {
                setAnchorElProduct(e.currentTarget);
                setProductId([item.product_id]);
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ProductCard;
